<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex">
            <p>감시소식 {{ state.idx === 0 ? "등록" : "수정" }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sign_form">
            <ul>
                <li :class="{ imp: state.mode }">
                    <label for="title" class="form_li_tit">제목</label>
                    <input id="title" type="text" v-model="state.data.title" />
                </li>
                <li class="li_con" :class="{ imp: state.mode }">
                    <label for="editor1" class="form_li_tit">내용</label>
                    <textarea id="editor1" class="custom_scroll" v-model="state.data.content"></textarea>
                </li>
                <li class="file_wrap">
                    <span class="form_li_tit">첨부</span>
                    <label for="area_file">
                        <input id="area_file" type="file" placeholder="" accept="image/*" multiple @change="handleFiles" />
                        <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하거나 파일을 드래그하여 첨부해주세요</div>
                        <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                        <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                    </label>
                    <div class="file_list">
                        <div class="file" v-for="(item, idx) in state.data.fileList" :key="idx">
                            <span class="file_name">{{ item.imgRealName }}</span>
                            <button class="file_del icon_wrap" @click="fileRemove(item.idx)">
                                <img src="img/close_02.png" alt="" />
                            </button>
                        </div>

                        <div class="file" v-for="(item, index) in state.file" :key="index">
                            <span class="file_name">{{ item.name }}</span>
                            <button class="file_del icon_wrap" @click="removeFile(index)">
                                <img src="img/close_02.png" alt="" />
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _main_blue" @click="save" v-text="state.mode ? '등록' : '수정'"></button>
            </div>
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts">
    import { onMounted, reactive, onUnmounted, types, apiService, CkEditorManager, ModalDefault, watch, getMessageByCode } from "@/BaseComponent";

    export default {
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: props.idx,
                data: {} as any,
                file: [] as Array<File>,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                mode: true as boolean, // true: add, false: modify
            });

            let editorManager: CkEditorManager | null = null;

            onMounted(async () => {
                if (props.data) {
                    state.data = props.data;
                    state.idx = state.data.idx;

                    state.mode = false;
                } else {
                    state.data = {};
                    state.idx = 0;

                    state.mode = true;
                }

                editorManager = new CkEditorManager("editor1", state.data, "suggestion");
                await editorManager.initEditor();
                await editorManager?.setDataInfo(state.data.content);
            });

            watch(props, async () => {
                if (props.data) {
                    state.data = props.data;
                    state.idx = state.data.idx;

                    state.mode = false;
                } else {
                    state.data = {};
                    state.idx = 0;

                    state.mode = true;
                }

                editorManager = new CkEditorManager("editor1", state.data, "suggestion");
                await editorManager.initEditor();
                await editorManager?.setDataInfo(state.data.content);
            });

            const closeModal = () => emit("close");
            const callBackModal = async (param: any) => {
                if (param.action === "callback") {
                    emit("callback");
                } else {
                    state.isShowModal = false;
                }
            };

            const save = async () => {
                if (!state.data.title) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "제목을 입력해주세요.";
                    state.isShowModal = true;
                } else if (!state.data.content) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "내용을 입력해주세요.";
                    state.isShowModal = true;
                } else {
                    if (state.mode) {
                        const param: types.ReqBoardForNews = {
                            idx: state.data.idx,
                            title: state.data.title,
                            content: (await editorManager?.getData()) + "",
                            file: state.file,
                        };

                        const res = await apiService.board.addForNews(param);

                        if (res.returnCode === 0) {
                            state.modalTab = 7;
                            state.modalTitle = "안내";
                            state.modalContent = "등록이 완료되었습니다.";
                            state.isShowModal = true;
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    } else {
                        const param: types.ReqBoardForNewsForModify = {
                            idx: state.data.idx,
                            title: state.data.title,
                            content: (await editorManager?.getData()) + "",
                            file: state.file,
                        };

                        const res = await apiService.board.modifyForNews(state.data.idx, param);

                        if (res.returnCode === 0) {
                            state.modalTab = 7;
                            state.modalTitle = "안내";
                            state.modalContent = "수정이 완료되었습니다.";
                            state.isShowModal = true;
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                }
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                const file = e.target.files[0];
                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    e.target.value = "";
                    return;
                }
                state.file = Array.from(e.target.files);
                target.value = "";
            };

            const removeFile = (index: number) => state.file.splice(index, 1);

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.board.removeFile(state.data.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = state.data.fileList.findIndex((item: any) => item.idx === idxFile);
                    if (index !== -1) {
                        state.data.fileList.splice(index, 1);
                    }
                }
            };

            return { state, closeModal, removeFile, save, handleFiles, fileRemove, callBackModal };
        },
    };
</script>
